/**
 * Sets up Content Security Policy for the application
 * This helps prevent XSS attacks
 */
export const setupCSP = () => {
  // Only run in production
  if (process.env.NODE_ENV !== 'production') return;
  
  // Create meta element for CSP
  const meta = document.createElement('meta');
  meta.httpEquiv = 'Content-Security-Policy';
  
  // Define CSP directives
  meta.content = `
    default-src 'self';
    connect-src 'self' https://api.wanttd.com https://api.test.wanttd.com https://accounts.google.com;
    script-src 'self' 'unsafe-inline' 'unsafe-eval';
    style-src 'self' 'unsafe-inline';
    img-src 'self' https: data:;
    font-src 'self' data:;
    frame-src 'self' https://accounts.google.com;
  `.replace(/\s+/g, ' ').trim();
  
  // Add to head
  document.head.appendChild(meta);
};

/**
 * Sanitizes user input to prevent XSS
 */
export const sanitizeInput = (input: string): string => {
  const div = document.createElement('div');
  div.textContent = input;
  return div.innerHTML;
};

// Import the functions directly from authService
import { initializeAuth, initializeTokensFromResponse } from '../services/authService';

// Re-export the functions
export { initializeAuth, initializeTokensFromResponse };
